import {Component, input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SimpleInputComponent} from "../simple-input/simple-input.component";
import {FormControlConverterPipe} from "../../pipe/form-control-converter.pipe";
import firebase from "firebase/compat";
import UserInfo = firebase.UserInfo;

@Component({
  selector: 'app-user-profile-form',
  templateUrl: './user-profile-form.component.html',
  styleUrls: ['./user-profile-form.component.scss'],
  imports: [
    SimpleInputComponent,
    FormControlConverterPipe
  ],
  standalone: true
})
export class UserProfileFormComponent  implements OnInit {

  userInfo = input<UserInfo>();

  registerForm: FormGroup = this.fb.group({
    email: [undefined, [Validators.required, Validators.email]],
    name: [undefined, [Validators.required]],
    lastName: [undefined, [Validators.required]],
    policyAccepted: [false]
  });

  constructor(private fb: FormBuilder) { }

  ngOnInit() {

    this.registerForm.patchValue(this.userInfo());
    this.registerForm.markAllAsTouched();
    this.registerForm.updateValueAndValidity();
  }

}
